import { IconWrapper } from '../runtime';
export default IconWrapper('close-eye', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M2 6.30286C1.30165 7.22588 1 7.99976 1 7.99976C1 7.99976 2.85149 12.7498 8 12.7498C8.17025 12.7498 8.3369 12.7446 8.5 12.7345M7.5 3.265C7.6631 3.25495 7.82975 3.24976 8 3.24976C13.1485 3.24976 15 7.99976 15 7.99976C15 7.99976 14.6984 8.77363 14 9.69666M3 2.99976L13 12.9998",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});